/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"
Vue.use(Vuex)

import moduleEquipments from "./equipments/moduleEquipments.js"
import moduleCustomers from "./customers/moduleCustomers.js"
import moduleSupplies from './supplies/moduleSupplies.js'
import moduleParts from './parts/moduleParts.js'
import moduleLabor from './labor/moduleLabor.js'
import moduleLease from './lease/moduleLease.js'
import moduleGold from './gold/moduleGold.js'
import moduleLeaseSupplies from './leaseSupplies/moduleLeaseSupplies.js'
import moduleEquipmentReview from './equipmentReview/moduleEquipmentReview.js'
export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
      equipments: moduleEquipments,
      customers: moduleCustomers,
      supplies: moduleSupplies,
      parts: moduleParts,
      labor: moduleLabor,
      lease: moduleLease,
      gold: moduleGold,
      leaseSupplies: moduleLeaseSupplies,
      equipmentReview: moduleEquipmentReview
  },
    strict: process.env.NODE_ENV !== 'production'
})
